import React from 'react';
import Modal from 'react-bootstrap/Modal';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ShopStyled } from '../../../features/shopSetting/assets/shopStyled';
import CircleCrossIcon from '../svgIcons/CircleCrossIcon';
import StyledText from '../styledComponents/StyledText';

const StyledModal = styled(Modal)`
  .modal-content {
    border-radius: 10px;
    font-family: ${({ theme }) => theme.fontFamily};
  }

  .modal-header {
    color: ${({ theme }) => theme.heading};
    font-family: ${({ theme }) => theme.fontFamily};
    .h4 {
      font-size: 20px;
    }
  }
  .modal-footer {
    justify-content: space-between;
    padding: 1rem;
  }
`;

const DeleteConfirmation = ({
  show,
  heading = 'Are You Sure?',
  deleteButtonText = 'Delete',
  cancelButtonText = 'Cancel',
  bodyText,
  onDelete,
  onCancel,
  isLoading = false,
}) => {
  return (
    <StyledModal show={show} onHide={onCancel} centered>
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title></Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center px-2 px-md-5">
        <StyledText color="error">
          <CircleCrossIcon />
        </StyledText>
        <StyledText
          
          as="h1"
          color="heading"
          $fontSize="30px"
          className="my-2 my-md-4"
        >
          {heading}
        </StyledText>
        <StyledText
          
          as="h1"
          color="bodyMedium"
          $fontSize="16px"
          className="mt-2 mt-md-4 "
          $fontWeight="400"
        >
          {bodyText ||
            'Do you want to delete this record? This process cannot be undone.'}
        </StyledText>
      </Modal.Body>
      <Modal.Footer
        className={
          'd-flex align-items-center justify-content-center border-0 pb-2 pb-md-4'
        }
      >
        <ShopStyled.EditButton
          color={'heading'}
          variant={'outline'}
          style={{
            boxShadow: 'none',
          }}
          onClick={onCancel}
          disabled={isLoading}
        >
          <ShopStyled.ButtonText>{cancelButtonText}</ShopStyled.ButtonText>
        </ShopStyled.EditButton>
        <ShopStyled.EditButton
          color={'primary'}
          onClick={onDelete}
          loading={isLoading}
          disabled={isLoading}
        >
          <ShopStyled.ButtonText>{deleteButtonText}</ShopStyled.ButtonText>
        </ShopStyled.EditButton>
      </Modal.Footer>
    </StyledModal>
  );
};

DeleteConfirmation.propTypes = {
  show: PropTypes.bool.isRequired,
  bodyText: PropTypes.string,
  onDelete: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default DeleteConfirmation;
